<footer>
  <div class="footer-description">
    <div class="container text-center">
      <div class="row">
        <div class="col"></div>
        <div class="col-lg-2">
          <img class="" style="width: 100%;" src="../../../../assets/img/logo/logo-qAIRa-sin-fondo.png" alt="">
          <div class="row mb-4 text-center">
            <div class="col-4">
              <a href="https://www.facebook.com/qAIRadrones/" target="_blank" rel="noopener noreferrer">
                <img width="50px" src="../../../../assets/img/INICIO/Icono facebook.svg" alt="">
              </a>
            </div>
            <div class="col-4">
              <a href="https://www.instagram.com/qaira_drones/" target="_blank" rel="noopener noreferrer">
                <img width="50px" src="../../../../assets/img/INICIO/Icono instagram.svg" alt="">
              </a>
            </div>
            <div class="col-4">
              <a href="https://pe.linkedin.com/company/qaira" target="_blank" rel="noopener noreferrer">
                <img width="50px" src="../../../../assets/img/INICIO/Icono linkedin.svg" alt="">
              </a>
            </div>
          </div>
          <p>Grupo Qaira S.A.C <br>
            <a href="tel:+51946749470">+51 946 749 470</a> <br>
            hola@qairadrones.com</p>
        </div>
        <div class="col"></div>
        <div class="col-lg-7 pt-4">
          <div class="flex-footer">
            <div class="flex-footer__text">
              <p>{{'footer.resume' | translate}}</p>
            </div>
          </div>
          <div class="q-footer__informacion">
            <strong>Información importante</strong>
            <ul>
              <li><a href="../../../../assets/Reports/Politica-de-Calidad-V02.pdf" target="_blank">{{'footer.qms' |
                  translate}}</a></li>
              <li><a href="https://www.qairadrones.com/libro-de-reclamaciones">{{'footer.libro_reclamaciones' |
                  translate}}</a></li>
            </ul>
          </div>
          <div class="q-certificate">
            <a href="https://www.sgs.com/en/certified-clients-and-products/certified-client-directory" target="_blank">
              <picture>
                <img data-src=" ../../../../assets/img/SGS_ISO_9001_TCL_HR.png"
                  data-srcset=" ../../../../assets/img/SGS_ISO_9001_TCL_HR.png  1x, ../../../../assets/img/SGS_ISO_9001_TCL_HR@2x.png  2x"
                  srcset=" ../../../../assets/img/SGS_ISO_9001_TCL_HR.png  1x, ../../../../assets/img/SGS_ISO_9001_TCL_HR@2x.png  2x"
                  src=" ../../../../assets/img/SGS_ISO_9001_TCL_HR.png" alt="ISO">
              </picture>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="foot text-white text-center text-sm">
    <div class="container py-3">
      <p class="m-0">© {{age}} Grupo Qaira S.A.C. {{'footer.rights' | translate}}</p>
    </div>
  </div>
  <a href="https://wa.me/946749470" target="_blank" class="is-whatsapp"><img src="../../../../assets/img/logo/whatsapp.svg" alt="" loading="lazy"></a>
</footer>